import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import "../../../assets/css/Modal.css";
import Ball from "../../../assets/Ball.svg";
import axiosInstance from "../../../store/services/AxiosService";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import { loadBankSoalData } from "../../../store/actions/index";

const delay = () => new Promise((res) => setTimeout(res, 1000));

class BankSoalModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMode: "examList", // 'examList' | 'questionList'
      fetching: false,
      
      // For examList mode
      itemCase: [],
      
      // For questionList mode
      selectedExamName: "",
      questions: [],
      
      // Cart (selected questions across all exams)
      cart: [],
      
      alertSuccess: null,
      alertFailure: null,
    };
  }

  componentDidUpdate = (prevProps) => {
    // Only fetch when modal opens and we haven't fetched yet
    if (this.props.show && !prevProps.show && this.state.itemCase.length === 0) {
      this.fetchExams();
    }
  };

  fetchExams = () => {
    // Attempt to get course ID from props, or Redux cases state if not available
    const idCourse = this.props.idcourse || this.props.cases?.course_id || this.props.cases?.api_course_id;
    const idSchool = this.props.schoolId;
    const idTeacher = this.props.teacherId;

    if (!idCourse) {
       this.setState({ alertFailure: "Silakan pilih Mata Pelajaran terlebih dahulu di form Buat Soal." });
       return;
    }

    this.setState({ fetching: true });
    axiosInstance
      .get(`/cases/course/${idCourse}/school/${idSchool}?teacher_id=${idTeacher}`)
      .then((res) => {
        this.setState({
          itemCase: res.data,
          fetching: false,
        });
      })
      .catch((error) => {
        this.setState({ fetching: false });
        console.error("Failed fetching cases", error);
      });
  };

  fetchQuestions = async (examId, examName) => {
    this.setState({ fetching: true, selectedExamName: examName });
    await delay();
    axiosInstance
      .get(`/cases/${examId}?type_user=teacher`)
      .then((res) => {
        const caseParts = res.data.case_parts || [];
        let allQuestions = [];
        
        caseParts.forEach((part) => {
          if (part.case_questions) {
            part.case_questions.forEach(q => {
               allQuestions.push({
                   ...q,
                   type_name: part.type_name,
                   part_name: part.name
               });
            });
          }
        });

        this.setState({
          questions: allQuestions,
          viewMode: "questionList",
          fetching: false,
        });
      })
      .catch((error) => {
        this.setState({ fetching: false });
        this.setState({ alertFailure: "Gagal mengambil butir soal dari paket ujian ini." });
      });
  };

  searchSoal = () => {
    const input = document.getElementById("inputSearchBank");
    if (!input) return;
    const filter = input.value.toUpperCase();
    const table = document.getElementById("tabelBankSoal");
    if (!table) return;
    const tr = table.getElementsByTagName("tr");
    for (let i = 0; i < tr.length; i++) {
      const td = tr[i].getElementsByTagName("td")[0]; // Nama Soal column
      if (td) {
        const txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  };

  handleCheckQuestion = (questionObj) => {
    const { cart } = this.state;
    // Check if already in cart
    const exists = cart.find(q => q.id === questionObj.id);
    
    if (exists) {
      // Remove it
      this.setState({ cart: cart.filter(q => q.id !== questionObj.id) });
    } else {
      // Add it
      this.setState({ cart: [...cart, questionObj] });
    }
  };

  renderExamList = () => {
    return (
      <div className="card custom-card-shadow">
        <div className="card-body">
          <h2 className="card-title">Bank Soal (Pilih Paket Ujian)</h2>
          <p className="card-description">
            Klik pada nama paket ujian untuk melihat dan memilih butir soal di dalamnya.
          </p>
          <div className="d-flex justify-content-between align-items-center mb-3">
             <input type="text" className="form-control" style={{ maxWidth: '300px' }} id="inputSearchBank" onChange={this.searchSoal} placeholder="Cari Nama Paket Ujian..." title="Cari Nama Paket" />
             <div className="badge badge-primary p-2" style={{ fontSize: '14px' }}>
                Keranjang: {this.state.cart.length} Soal
             </div>
          </div>
          <div className="table-responsive">
            <table id="tabelBankSoal" className="table table-hover text-center modal-list-case">
              <thead>
                <tr>
                  <th scope="col">Nama Paket Ujian</th>
                  <th scope="col">Total Soal</th>
                  <th scope="col">Tanggal Buat</th>
                  <th scope="col">Aksi</th>
                </tr>
              </thead>
              <tbody>
                {this.state.itemCase.length > 0 ? (
                  this.state.itemCase.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-left font-weight-bold">{item.name}</td>
                      <td>{item.total_cases || (item.case_parts ? item.case_parts.reduce((acc, part) => acc + part.case_questions.length, 0) : '-')}</td>
                      <td>{new Date(item.created_at).toLocaleDateString("id-ID")}</td>
                      <td>
                        <button className="btn btn-sm btn-info" onClick={() => this.fetchQuestions(item.id, item.name)}>Lihat Soal</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-4">Paket ujian tidak ditemukan / belum ada paket ujian untuk mata pelajaran ini.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  handleSelectAll = () => {
    const { questions, cart } = this.state;
    // Check if all questions in the current view are selected
    const allSelected = questions.every(q => cart.some(cartItem => cartItem.id === q.id));

    if (allSelected) {
      // Deselect all
      const newCart = cart.filter(cartItem => !questions.some(q => q.id === cartItem.id));
      this.setState({ cart: newCart });
    } else {
      // Select all
      let newCart = [...cart];
      questions.forEach(q => {
        if (!newCart.some(cartItem => cartItem.id === q.id)) {
          newCart.push(q);
        }
      });
      this.setState({ cart: newCart });
    }
  };

  renderQuestionList = () => {
    const { questions, cart } = this.state;
    const allSelected = questions.length > 0 && questions.every(q => cart.some(cartItem => cartItem.id === q.id));

    return (
      <div className="card custom-card-shadow">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
             <button className="btn btn-sm btn-secondary mr-3" onClick={() => this.setState({ viewMode: 'examList', questions: [] })}>
               <i className="mdi mdi-arrow-left"></i> Kembali
             </button>
             <h2 className="card-title mb-0">Pilih Soal dari: {this.state.selectedExamName}</h2>
          </div>
          <p className="card-description">
            Centang soal yang ingin Anda ambil, soal akan otomatis masuk ke keranjang.
          </p>
          <div className="d-flex justify-content-between align-items-center mb-3">
             <button className="btn btn-sm btn-outline-primary" onClick={this.handleSelectAll} disabled={questions.length === 0}>
               {allSelected ? (
                  <><i className="mdi mdi-checkbox-multiple-marked-outline mr-1"></i> Batal Pilih Semua</>
               ) : (
                  <><i className="mdi mdi-checkbox-multiple-blank-outline mr-1"></i> Pilih Semua</>
               )}
             </button>
             <div className="badge badge-primary p-2" style={{ fontSize: '14px' }}>
                Keranjang: {this.state.cart.length} Soal
             </div>
          </div>
          <div className="list-group" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {this.state.questions.length > 0 ? (
              this.state.questions.map((q, index) => {
                const isChecked = this.state.cart.some(cartItem => cartItem.id === q.id);
                return (
                  <div 
                    className={`list-group-item list-group-item-action d-flex align-items-start ${isChecked ? 'list-group-item-primary' : ''}`} 
                    key={q.id} 
                    style={{ cursor: 'pointer', border: isChecked ? '2px solid #007bff' : '1px solid #e3e3e3', marginBottom: '10px', borderRadius: '5px' }} 
                    onClick={() => this.handleCheckQuestion(q)}
                  >
                    <div className="mr-4 mt-1">
                      <input 
                        type="checkbox" 
                        checked={isChecked}
                        onChange={() => {}} // handled by row onClick
                        style={{ width: '25px', height: '25px', cursor: 'pointer' }}
                      />
                    </div>
                    <div className="flex-grow-1" style={{ maxWidth: '100%', overflow: 'hidden' }}>
                      <div className="mb-2">
                         <span className="badge badge-primary">{q.type_name}</span>
                      </div>
                      <div className="question-content-wrapper" style={{ wordWrap: 'break-word', overflowX: 'auto' }}>
                         <div dangerouslySetInnerHTML={{ __html: q.question }} />
                      </div>
                      {q.file_attached && (
                        <div className="mt-3">
                           <img src={process.env.REACT_APP_BACKEND_IMAGES2 + q.file_attached} alt="Lampiran Soal" style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain', borderRadius: '4px', border: '1px solid #ddd' }} />
                        </div>
                      )}
                      {q.video_embed && (
                        <div className="mt-2 text-muted">
                           <small><i className="mdi mdi-link"></i> Soal memiliki URL berikut: <a href={q.video_embed} target="_blank" rel="noopener noreferrer">{q.video_embed}</a></small>
                        </div>
                      )}
                    </div>
                  </div>
                )
              })
            ) : (
              <div className="text-center py-4 text-muted">Tidak ada soal dalam paket ini.</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  btnSubmitCart = () => {
    if (this.state.cart.length === 0) {
      this.setState({ alertFailure: "Keranjang masih kosong, pilih minimal 1 soal." });
      return;
    }
    
    // Dispatch action to Redux
    this.props.loadBankSoalData(this.state.cart);
    
    const alertSuccess = () => (
      <SweetAlert success title="Berhasil!" onConfirm={() => this.closeAndReset()}>
        {this.state.cart.length} soal berhasil dimuat ke halaman Buat Soal!
      </SweetAlert>
    );
    this.setState({ alertSuccess: alertSuccess() });
  };

  closeAndReset = () => {
    this.setState({ alertSuccess: null, cart: [], viewMode: 'examList', questions: [] });
    this.props.onHide();
  };

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
           <Modal.Title id="contained-modal-title-vcenter">
             Tarik dari Bank Soal
           </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.fetching ? (
            <div className="text-center py-5">
              <img src={Ball} alt="Loading..." />
              <p className="mt-3">Memuat data...</p>
            </div>
          ) : (
            this.state.viewMode === "examList" ? this.renderExamList() : this.renderQuestionList()
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.onHide}>Batal</Button>
          <Button variant="success" onClick={this.btnSubmitCart} disabled={this.state.cart.length === 0}>
            Muat ke Form Ujian ({this.state.cart.length})
          </Button>
        </Modal.Footer>
        
        {this.state.alertSuccess}
        {this.state.alertFailure && (
          <SweetAlert warning title="Perhatian" onConfirm={() => this.setState({ alertFailure: null })}>
            {this.state.alertFailure}
          </SweetAlert>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    schoolId: state.User.dataSchool.value,
    teacherId: state.User.dataTeacher.user.data_employee.employee_id,
    cases: state.Exam.cases,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadBankSoalData: (questions) => dispatch(loadBankSoalData(questions)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BankSoalModal);
